<template>
    <div id="full" class="container-display" :class="{'container-full-display': fullScreenDisplay}">
        <section class="content-data">
            <div class="ticket-data-client">
                <div class="ticket">
                    <span v-if="currentCall">{{ currentCall.id }}</span>
                    <span v-else>-</span>
                </div>

                <div class="data-client">
                    <span v-if="currentCall">{{ currentCall.customer_name }}</span>
                    <span v-else>-</span>
                </div>

                <div class="responsible-client">
                    Responsável:
                    <span v-if="responsible">{{ responsible.first_name }}</span>
                    <span v-else>-</span>
                </div>
            </div>

            <div class="img-facilita">
                <img class="img" src="https://cdn.appfacilita.com/_uploads/companies/facilita/configurations/brandLogo.png?v=1">
            </div>
        </section>

        <section class="content-card">
            <div class="icon-full-screen" @click="toggleFullScreen">
                <em class="fas fa-expand-alt" />
            </div>

            <div class="last-calls">ÚLTIMOS CHAMADOS</div>

            <div v-for="(customer, index) in customersComputed" :key="index" class="data-card">

                <div class="client-ticket-card">
                    <div class="ticket-card">{{ customer.id }}</div>
                    <div class="client-card">{{ abbreviateName(customer.customer_name) }}</div>
                </div>
            </div>
            <div class="menu-card">
                <ui-menu-card icon="fal fa-cog" prop-style="color:#fff" >
                    <button @click="setSound">
                        <div style="margin-right: 5px"><em class="far" :class="icon"></em> </div>
                        <span>{{(sound ? ' Som Ativado': 'Som Desativado') }} </span>
                    </button>
                    <ui-select
                        v-model="newMusic"
                        v-if="sound"
                        inline
                        size="md"
                        @change="setStartMusic"
                        class="menu-card-select"
                    >
                        <option v-for="(music, id) in musics" :key="id" :value="music.value">
                            {{ music.name }}
                        </option>
				</ui-select>
                </ui-menu-card>
            </div>
        </section>
    </div>
</template>

<script>
    import { facilita } from '@/global'
    import { uiMenuCard } from '@/components/ui'
    import { uiSelect } from '@/components/ui/form'
    import { mapActions, mapGetters } from 'vuex'
    import { storage } from '@/services/storage'

    export default {
        name: "ui-display",
        components: {
            uiMenuCard,
            uiSelect
        },
        data() {
            return {
                customers: [],
                currentCall: null,
                fullScreenDisplay: false,
                sound: true,
                icon: 'fa-music',
                audio: '',
                setMusic: 'airport-bingbong',
                newMusic: 'airport-bingbong',
                musics: [
                    {
                        name: 'airport',
                        value: 'airport-bingbong'
                    },
                    {
                        name: 'ding dong',
                        value: 'ding-dong'
                    },
                    {
                        name: 'doorbell',
                        value: 'doorbell-bingbong'
                    },
                    {
                        name: 'ekiga',
                        value: 'ekiga-vm'
                    },
                    {
                        name: 'infobleep',
                        value: 'infobleep'
                    },
                    {
                        name: 'quito mariscal',
                        value: 'quito-mariscal-sucre'
                    },
                    {
                        name: 'toydoorbell',
                        value: 'toydoorbell'
                    },
                ]
            }
        },

        mounted() {
            this.subscribe()
            let music = storage.get('alarm-sound')
            if(music) this.audio = new Audio(require(`./sounds/${music}.wav`))
            else storage.set('alarm-sound', this.newMusic)
        },

        beforeDestroy() {
            this.unsubscribe()
        },

        computed: {
            ...mapGetters('launchDay', {
                pusher: 'getPusher'
            }),
            /**
             * Computed property que formata o array de clientes/negócios para mostrar todos os
             * itens, exceto o primeiro
             */
            customersComputed() {
                return this.customers.slice(1)
            },
            /**
             * Computed property que retorna o responsável pelo negócio/cliente
             */
            responsible() {
                let owner = null

                if (this.currentCall && this.currentCall.owners) {
                    if (this.currentCall.owners.broker) {
                        owner = { ...this.currentCall.owners.broker.user }

                    } else if (this.currentCall.owners.manager) {
                        owner = { ...this.currentCall.owners.manager.user }

                    } else {
                        owner = { ...this.currentCall.owners.owner }
                    }
                }

                return owner
            }
        },

        methods: {
            ...mapActions('launchDay', [
                'setPusher',
                'removePusher'
            ]),
            /**
             * Define se a tela será mostrada em fullscreen ou não
             */
            alarm() {
                this.audio.play()
            },
            setSound() {
                this.sound = !this.sound
                this.icon = this.sound ? 'fa-music' : 'fa-music-slash'
            },
            setStartMusic() {
                if(this.setMusic !== this.newMusic) {
                    this.setMusic = this.newMusic
                    storage.set('alarm-sound', this.newMusic)
                    this.audio = new Audio(require(`./sounds/${this.setMusic}.wav`))
                    this.audio.play()
                }
            },

            toggleFullScreen() {
                const div = document.querySelector('#full');

                if ((document.fullScreenElement && document.fullScreenElement !== null) ||
                    (!document.mozFullScreen && !document.webkitIsFullScreen)) {
                        this.fullScreenDisplay = true
                        if (div.requestFullScreen) {
                            div.requestFullScreen();
                        } else if (div.mozRequestFullScreen) {
                            div.mozRequestFullScreen();
                        } else if (div.webkitRequestFullScreen) {
                            div.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                        }
                } else {
                    if (document.cancelFullScreen) {
                        this.fullScreenDisplay = false
                        document.cancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        this.fullScreenDisplay = false
                        document.mozCancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        this.fullScreenDisplay = false
                        document.webkitCancelFullScreen();
                    }
                }
            },
            /**
             * Seta os dados do último cliente chamado para ser mostrado
             */
            setCurrentCall() {
                if (!this.customers.length) return

                const customer = this.customers[0]
                let counter = 0
                const interval = setInterval(() => {
                    if(this.sound) {
                        this.alarm()
                    }
                    if (counter >= 3) {
                        clearInterval(interval)
                        this.currentCall = { ...customer }

                    } else {
                        counter += 1
                        this.currentCall = { ...customer }
                        setTimeout(() => {
                            this.currentCall = null
                        }, 1000)
                    }
                }, 2000)
            },
            /**
             * Se cadastra para ficar escutando os envios do websocket no canal de clientes
             * chamados
             */
            subscribe: async function () {
                // Inicializa a conexão com o Pusher caso esta ainda não exista
                if (!this.pusher) await this.setPusher()

                this.pusher.subscribe(facilita.instance)
                this.pusher.bind('called_customer', data => {
                    const index = this.customers.findIndex(customer => customer.id === data.id)
                    /**
                     * Verifica se o item recebido já está no array. Se sim, move este para o primeiro da lista
                     */
                    if (index >= 0) this.customers.splice(index, 1)
                    this.customers.unshift(data)
                    /**
                     * Caso a lista esteja com mais de 5 itens, remove o último item
                     */
                    if (this.customers.length > 5) this.customers.pop()
                    this.setCurrentCall()
                })
            },
            /**
             * Desativa a conexão com o canal de clientes chamados via websocket
             */
            unsubscribe() {
                this.pusher.unsubscribe()
                this.removePusher()
            },
            /**
             * Realiza a abreviação do nome de um cliente e a retorna
             */
            abbreviateName(name) {
                let names = name.trim().split(" ")
                let abbreviation = names[0]

                if (names.length > 1) {
                    for (name of names.slice(1)) {
                        abbreviation += ` ${name[0]}.`
                    }
                }

                return abbreviation
            }
        },
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>